const ukPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;
const auPostcodeRegex = /^\d{4}$/;

export const validatePostcode = (postcode: string): string => {
  const trimmed = postcode.trim();
  const isValid = ukPostcodeRegex.test(trimmed) || auPostcodeRegex.test(trimmed);
  return isValid ? '' : 'Postcode does not match a UK or Australian postcode format';
};
